import { render, staticRenderFns } from "./seriesCategoryPage.vue?vue&type=template&id=2d8688e2&"
import script from "./seriesCategoryPage.vue?vue&type=script&lang=js&"
export * from "./seriesCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports